import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import AboutSection from '../AboutPage/AboutSection';
import Whychoos_as from '../AboutPage/Whychoos_as';
import Allpagesbanners from '../components/Allpagesbanners';
import OurTeam from '../AboutPage/OurTeam';
import Aboutpagebanner from '../components/Aboutpagebanner';
function About() {
  return (
    <div>
        <Header/>
        <Aboutpagebanner/>
         <AboutSection/>
    <Whychoos_as/>
    <OurTeam/>
    <Footer/>
    </div>
  )
}

export default About
